module.exports = __webpack_public_path__ + "media/images/games/k2gender/drawing-9befa3d493bb0f15d103c40e865cb8df.png";